import { Component, EventEmitter, Input, Output, Optional, Inject } from '@angular/core';
import { IssueReportingService } from '@content-platform/web-angular-shared-util-error-handling';
import { UserRequestDialogService } from '@content-platform/reusable-ui/user-request';
import { DebugFlagsDialogService } from '@content-platform/reusable-ui/feature-flags';
import { DEBUG_FLAG_KEY } from '@content-platform/web-angular-shared-util-development';

import { UserMenuItem } from './user-menu-item';
import { NAVIGATION_OPTIONS, NavigationOptions } from '../../navigation-options';
import { userProfileHelpers } from '@content-platform/web-angular-administration-shared-data-access-graph-api';

/**
 * Component to display the user menu settings
 *
 * @export
 * @class UserProfileComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-user-menu',
  templateUrl: './user-menu.component.html',
  styleUrls: ['./user-menu.component.scss']
})
export class UserMenuComponent {
  @Input()
  user: adal.User;
  @Input()
  additionalMenuItems: UserMenuItem[];
  @Output()
  logout = new EventEmitter<void>();

  /**
   * Getter to get the displayName from User object
   *
   * @readonly
   * @type {string}
   * @memberof UserProfileComponent
   */
  get displayName(): string {
    return userProfileHelpers.getDisplayName(this.user, { undefinedIfNotFound: true }) || 'Login';
  }

  get impersonatingTooltip() {
    let name = userProfileHelpers.getDisplayName(this.user);

    if (name) {
      name += '\n';
    }
    name += userProfileHelpers.getEmailAddress(this.user);
    return name;
  }

  get production() {
    return this.navigationOptions && this.navigationOptions.production;
  }

  get debugFlag() {
    return DEBUG_FLAG_KEY;
  }

  reportIssue() {
    this.issueReportingService.reportIssue();
  }

  requestNewUser() {
    this.userRequestDialogService.showInviteUserModal();
  }

  showDebugFlags() {
    this.debugFlagService.showDebugFlagsModal();
  }

  constructor(
    @Inject(NAVIGATION_OPTIONS) private navigationOptions: NavigationOptions,
    @Optional() private issueReportingService: IssueReportingService,
    @Optional() private debugFlagService: DebugFlagsDialogService,
    private userRequestDialogService: UserRequestDialogService
  ) {}
}
